import React from "react";
import { StyledButton, CurrencyValue, InfoTooltip } from "components/support";
import Paper from "material-ui-next/Paper";
import { Row, Col } from "react-flexbox-grid";
import "chartkick";
import { LineChart } from "react-chartkick";
import { FormattedNumber } from "react-intl";
import Big from "big.js";

class HistoryGraph extends React.Component {
  render() {
    return (
      <Paper elevation={1}>
        <div style={historyIndicators} className="history-indicators">
          <Row>
            <Col
              xs={12}
              sm={6}
              md
              style={historyIndicator}
              className="history-indicator"
            >
              <div style={paddingStyle} className="history-indicator-inner">
                <strong style={blockDisplayStyle}>
                  Faturamento Total
                  <InfoTooltip hint="Inclui faturamento dos opcionais." />
                </strong>
                <span className="value">
                  <CurrencyValue
                    value={this.props.result.total_revenues}
                    type="money"
                  />
                </span>
              </div>
            </Col>
            <Col
              xs={12}
              sm={6}
              md
              style={historyIndicator}
              className="history-indicator"
            >
              <div style={paddingStyle} className="history-indicator-inner">
                <strong style={blockDisplayStyle}>Descontos</strong>
                <span className="value">
                  <CurrencyValue
                    value={this.props.result.total_discount}
                    type="money"
                  />
                </span>
              </div>
            </Col>
            <Col
              xs={12}
              sm={6}
              md
              style={historyIndicator}
              className="history-indicator"
            >
              <div style={paddingStyle} className="history-indicator-inner">
                <strong style={blockDisplayStyle}>
                  Custos
                  <InfoTooltip hint="Não são considerados os custos dos opcionais." />
                </strong>
                <span className="value">
                  <CurrencyValue
                    value={this.props.result.total_costs}
                    type="money"
                  />
                </span>
              </div>
            </Col>
            <Col
              xs={12}
              sm={6}
              md
              style={historyIndicator}
              className="history-indicator"
            >
              <div style={paddingStyle} className="history-indicator-inner">
                <strong style={blockDisplayStyle}>Lucro</strong>
                <span className="value">
                  <CurrencyValue
                    value={this.props.result.profit}
                    type="money"
                  />
                </span>
              </div>
            </Col>
            <Col xs={12} sm={6} md className="history-indicator">
              <div style={paddingStyle} className="history-indicator-inner">
                <strong style={blockDisplayStyle}>Margem de Lucro</strong>
                <span className="value">
                  <FormattedNumber
                    value={Big(this.props.result.margin || 0)
                      .times(100)
                      .toFixed(2)}
                  />
                  %
                </span>
              </div>
            </Col>
          </Row>
        </div>
        <div className="text-right">
          <StyledButton
            accent
            label="Relatório de Vendas"
            onTouchTap={this.props.onTouchTap}
          />
        </div>

        <div style={paddingStyle} className="graph-container">
          <LineChart
            xtitle="Período"
            ytitle="Valor (R$)"
            data={this.props.dataGraph}
            thousands="."
            decimal=","
          />
        </div>
      </Paper>
    );
  }
}

const historyIndicators = {
  boxShadow: "rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px",
  marginBottom: 16
};

const historyIndicator = {
  borderRight: "1px solid #CCC"
};

const paddingStyle = {
  padding: 8
};

const blockDisplayStyle = {
  display: "flex",
  alignItems: "center"
};

export default HistoryGraph;



// WEBPACK FOOTER //
// ./src/components/app/history/dashboard/history-graph/view.jsx